import React, { useState } from 'react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import './ShareStoryModal.css';

const ShareStoryModal = ({ story, isOpen, onClose, language = 'de' }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen || !story) return null;

  // Generate public PDF view link (no authentication required)
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const shareUrl = `${BACKEND_URL}/api/stories/${story.id}/view-pdf`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success(language === 'de' ? 'Link kopiert!' : 'Link copied!');
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast.error(language === 'de' ? 'Fehler beim Kopieren' : 'Failed to copy');
    }
  };

  const handleShare = (platform) => {
    const title = `${story.title} - StoryTales`;
    const text = language === 'de' 
      ? `Schau dir diese magische Geschichte als PDF an: ${story.title}`
      : `Check out this magical story as PDF: ${story.title}`;

    let url;
    switch (platform) {
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(text)}`;
        break;
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(text + ' ' + shareUrl)}`;
        break;
      case 'email':
        url = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + '\n\n' + shareUrl)}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank', 'width=600,height=400');
  };

  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div className="share-modal" onClick={(e) => e.stopPropagation()}>
        <div className="share-modal-header">
          <h2>{language === 'de' ? 'Geschichte teilen' : 'Share Story'}</h2>
          <button className="share-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="share-modal-body">
          <div className="share-story-preview">
            {story.pages && story.pages[0]?.image_url && (
              <img src={story.pages[0].image_url} alt={story.title} />
            )}
            <h3>{story.title}</h3>
          </div>

          <div className="share-link-section">
            <label>{language === 'de' ? 'Link teilen:' : 'Share link:'}</label>
            <div className="share-link-input">
              <input type="text" value={shareUrl} readOnly />
              <Button onClick={handleCopyLink} className="copy-button">
                {copied ? '✓' : '📋'} {copied ? (language === 'de' ? 'Kopiert!' : 'Copied!') : (language === 'de' ? 'Kopieren' : 'Copy')}
              </Button>
            </div>
          </div>

          <div className="share-platforms">
            <p>{language === 'de' ? 'Oder teile auf:' : 'Or share on:'}</p>
            <div className="share-buttons">
              <button className="share-btn twitter" onClick={() => handleShare('twitter')}>
                <span className="share-icon">🐦</span>
                Twitter
              </button>
              <button className="share-btn whatsapp" onClick={() => handleShare('whatsapp')}>
                <span className="share-icon">💬</span>
                WhatsApp
              </button>
              <button className="share-btn email" onClick={() => handleShare('email')}>
                <span className="share-icon">✉️</span>
                Email
              </button>
            </div>
            <p style={{ fontSize: '0.85em', color: '#666', marginTop: '10px', fontStyle: 'italic' }}>
              {language === 'de' 
                ? '💡 Tipp: Facebook unterstützt keine direkten PDF-Links. Verwenden Sie "Link kopieren" und fügen Sie ihn manuell in Facebook ein.' 
                : '💡 Tip: Facebook doesn\'t support direct PDF links. Use "Copy Link" and paste it manually on Facebook.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareStoryModal;
